import com.checkin.host.HostApp
import com.checkin.host.theme.AppThemeHolder
import org.jetbrains.compose.web.renderComposable

fun main() {
    AppThemeHolder.init()
    renderComposable(rootElementId = "root") {
        HostApp()
    }
}
